export enum MutationTypes {
  SET_LOADING_STATUS = "SET_LOADING_STATUS",
  SET_CSRF_INFORMATION = "SET_CSRF_INFORMATION",
  SET_BANNER_STATUS = "SET_BANNER_STATUS",
  SET_DIALOG_STATUS = "SET_DIALOG_STATUS",
  SET_NOTIFICATION_STATUS = "SET_NOTIFICATION_STATUS",
  SET_ALERT_STATUS = "SET_ALERT_STATUS"
}
